import api from "./axios";

export const getGRNs = () =>
  api.get("/grn");

export const createGRN = (data) =>
  api.post("/grn", data);